module.exports = __webpack_public_path__ + "static/media/armchair.9bffa700.svg";